<template>
  <!-- Navigation Header -->
  <navigation-header />

  <!-- Page Content -->
  <main>
    <slot></slot>
  </main>

  <!-- Chat -->
  <chat />

  <!-- Language -->
  <language />

  <!-- Scroll -->
  <scroll-to-top />

  <!-- Cursor -->
  <cursor />

  <!-- Navigation Footer -->
  <navigation-footer />
</template>

<style>
</style>

<script>
import Chat from '@/Components/Chat.vue';
import Cursor from '@/Components/Cursor.vue';
import Language from '@/Components/Language.vue';
import NavigationFooter from '@/Components/Footer.vue';
import NavigationHeader from '@/Components/Header.vue';
import ScrollToTop from '@/Components/ScrollToTop.vue';

export default {
  components: {
    Chat,
    Cursor,
    Language,
    NavigationFooter,
    NavigationHeader,
    ScrollToTop
  }
};
</script>